import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import _ from 'lodash';
import  dateFormat from 'dateformat';

import Video from "./Video";
import FormVideo from "./forms/FormVideo";

@inject('videoStore')
@inject('videoForm')
@observer
export default class VideoList extends Component {

    render() {
        let { isLoggedIn } = this.props;        
        var videoForm = this.props.videoForm;
        var videoList = _(this.props.videoStore.videos).groupBy(item => dateFormat(item.lastchangeddatetime, "mmm dd, yyyy")).map(function (value, key) {
        
            return <div className="post-sublist" key={key}><div className="post-sublist-date">{key}</div>
                <div className="post-sublist-list">
                    {value.map(video => (<Video video={video} key={video.id} videoForm={videoForm} isLoggedIn={isLoggedIn}/>))}
                </div></div>;
        }).value();

        return (
            <div className="postlistcontainer">
                <div className="postlist-header"><span className="spanNews">{this.props.videoForm.display && isLoggedIn ? 'Add New Video' : 'Training Videos'}</span>
                    {!this.props.videoForm.display && isLoggedIn &&
                        <button
                        type="button"
                        onClick={() => {
                            this.props.videoForm.display = true;
                        }}
                        className="add-new-post"
                        text={"Add New"}><span>+</span>Add New</button>}
                </div>
                {isLoggedIn && <FormVideo form={this.props.videoForm} />}
                {videoList}
            </div >
        );
    }

}


// WEBPACK FOOTER //
// ./src/components/VideoList.jsx